import React, { useState } from "react";
import { motion } from "framer-motion";
import Layout from "../components/Layout";
import api from "../lib/api";

const ELEMENT_COLORS = { Wood: "#4F8176", Fire: "#C25B4E", Earth: "#C59B27", Metal: "#8C8C8C", Water: "#3E5C76" };

export default function ChineseAstrology() {
  const [form, setForm] = useState({ year: "", month: "1", day: "1" });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.get("/astrology", { params: { year: Number(form.year), month: Number(form.month), day: Number(form.day) } });
      setResult(data);
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <div className="section-pad max-w-4xl mx-auto">
        <div className="text-center">
          <span className="pill bg-brand-cream2 text-brand-tan">Free For Everyone</span>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold text-brand-ink mt-3">Chinese Astrology & Five Elements</h1>
          <p className="mt-3 text-brand-inksoft max-w-xl mx-auto">Discover your birth animal, element, and energetic polarity — instantly calculated from your birth date.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-10 items-start">
          <form onSubmit={submit} data-testid="astrology-calculator-form" className="card-surface p-7 space-y-4">
            <div>
              <label className="text-sm font-medium text-brand-ink">Birth Year</label>
              <input data-testid="astro-year" type="number" required min="1900" max="2100" placeholder="e.g. 1988" className="input-field mt-1" value={form.year} onChange={(e) => setForm({ ...form, year: e.target.value })} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium text-brand-ink">Month</label>
                <input data-testid="astro-month" type="number" min="1" max="12" className="input-field mt-1" value={form.month} onChange={(e) => setForm({ ...form, month: e.target.value })} />
              </div>
              <div>
                <label className="text-sm font-medium text-brand-ink">Day</label>
                <input data-testid="astro-day" type="number" min="1" max="31" className="input-field mt-1" value={form.day} onChange={(e) => setForm({ ...form, day: e.target.value })} />
              </div>
            </div>
            <button data-testid="astro-submit" disabled={loading} className="btn-primary w-full">{loading ? "Calculating…" : "Reveal My Reading"}</button>
          </form>

          <div className="card-surface p-7 min-h-[240px] flex items-center justify-center" data-testid="astro-result">
            {result ? (
              <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} className="text-center">
                <div className="w-20 h-20 rounded-full mx-auto flex items-center justify-center text-white font-display text-2xl"
                  style={{ background: ELEMENT_COLORS[result.element] || "#4E6E5D" }}>
                  {result.element[0]}
                </div>
                <h3 className="font-display text-3xl font-semibold text-brand-ink mt-4">{result.polarity} {result.element} {result.animal}</h3>
                <p className="mt-3 text-brand-inksoft text-sm leading-relaxed">{result.reading}</p>
              </motion.div>
            ) : (
              <p className="text-brand-muted text-center">Enter your birth date to see your Five Elements profile.</p>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
